module.exports = __webpack_public_path__ + "img/data1.e438a4b4.png";